import { MenuItem, Select } from "@mui/material";
import {
  DETAIL_TAB,
  DETAIL_TAB2POINT_CLOUD_TYPE,
  EDisplayType,
  EViewerMode,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";
import { t } from "i18next";
import { ECoordinateTransformMode } from "../../config/componentsConfig";
import { Q3DSelect, TQ3DSelectItem } from "../../Parts/Q3DSelect";
import { useContext, useEffect, useState } from "react";
import { Common } from "../../../../common/src";
import { PROJECT_STATUS_LIST } from "../../../../common/src/modules";
import { HelmInput } from "./HelmInput";
import { HelmTransform } from "./HelmTransform";
import { HelmVerification } from "./HelmVerification";
import HelmContext from "../Contexts/HelmContext";

type Props = {
  width?: string;
};

export const HelmTabPanel = (props: Props) => {
  const { projectDetail, detailTab, currentViewerMode, viewer, displayType } =
    useContext(ProjectDetailContext);
  const { currentHelmTab, setCurrentHelmTab } = useContext(HelmContext);

  useEffect(() => {
    switch (detailTab) {
      case DETAIL_TAB.SFM:
        setCurrentHelmTab(ECoordinateTransformMode.TRANSFORM);
        break;
      case DETAIL_TAB.HELMERT:
        setCurrentHelmTab(ECoordinateTransformMode.VERIFICATION);
    }
  }, [detailTab]);

  // 座標変換モードに入った際の処理
  useEffect(() => {
    if (currentViewerMode !== EViewerMode.HELMERT_TRANSFORM) return;

    switch (DETAIL_TAB2POINT_CLOUD_TYPE(detailTab)) {
      case Common.POINT_CLOUD_TYPE.SIMPLE:
        setCurrentHelmTab(ECoordinateTransformMode.INPUT);
        break;
      case Common.POINT_CLOUD_TYPE.SFM:
        setCurrentHelmTab(ECoordinateTransformMode.TRANSFORM);
        break;
      case Common.POINT_CLOUD_TYPE.HELMERT:
        setCurrentHelmTab(ECoordinateTransformMode.VERIFICATION);
        break;
      default:
        setCurrentHelmTab(ECoordinateTransformMode.INPUT);
    }

    return () => {
      viewer.deleteAllPickPoint();
    };
  }, [currentViewerMode]);

  // currentHelmTabを変更した際の処理は各パネルに記載する

  const isShowSfmTab = (status: PROJECT_STATUS_LIST) => {
    return (
      (status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.verification_helmert === Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.verification_sfm === Common.PROJECT_STATUS_ENUM.COMPLETED) &&
      detailTab === DETAIL_TAB.SFM
    );
  };

  const isShowHelmTab = (status: PROJECT_STATUS_LIST) => {
    const useViDoc = projectDetail?.useViDoc;
    return (
      ((status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.verification_helmert === Common.PROJECT_STATUS_ENUM.COMPLETED ||
        status.verification_sfm === Common.PROJECT_STATUS_ENUM.COMPLETED) &&
        detailTab === DETAIL_TAB.SFM &&
        useViDoc) ||
      detailTab === DETAIL_TAB.HELMERT
    );
  };

  const helmTabItems = () => {
    const items: TQ3DSelectItem[] = [];
    items.push({
      value: ECoordinateTransformMode.INPUT,
      label: t("COORD_INPUT"),
    });
    isShowSfmTab(projectDetail?.status) &&
      items.push({
        value: ECoordinateTransformMode.TRANSFORM,
        label: t("COORDINATE_TRANSFOR"),
      });
    isShowHelmTab(projectDetail?.status) &&
      items.push({
        value: ECoordinateTransformMode.VERIFICATION,
        label: t("VALID_POINT_ACCURACY_CHECK"),
      });
    return items;
  };

  const helmTabMain = () => {
    switch (currentHelmTab) {
      case ECoordinateTransformMode.INPUT:
        return <HelmInput />;
      case ECoordinateTransformMode.TRANSFORM:
        return <HelmTransform />;
      case ECoordinateTransformMode.VERIFICATION:
        return <HelmVerification />;
      default:
        return <></>;
    }
  };

  return (
    <Q3DTabPanel
      value={EViewerMode.HELMERT_TRANSFORM}
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        gap: "4px",
        width: props.width,
        paddingLeft: "4px !important",
      }}
    >
      <Q3DSelect
        label="mode"
        items={helmTabItems()}
        value={currentHelmTab}
        setValue={(v) => {
          setCurrentHelmTab(v as ECoordinateTransformMode);
        }}
        height={"36px"}
        sx={{ fontSize: "14px" }}
        maxWidth={displayType === EDisplayType.Web ? "infinity" : ""}
      />
      {helmTabMain()}
    </Q3DTabPanel>
  );
};
